<div id="show-student" class="row" *ngIf="!loading">
<div class='col-12'>
    <table class="table">
        <tr>
            <th> Names</th>
            <th> User Id</th>
        </tr>
        <tr>
            <th> {{student.fullname}}</th>
            <th> {{student.server_user_id}}</th>
        </tr>
    </table>
    <fieldset class="buttons text-center">
        <button class="delete btn btn-danger me-4" (click)="deleteStudent()" >Delete</button>
        <button class="delete btn btn-primary" (click)="indexStudent()" >Cancel</button>
         </fieldset>
</div>
<div class='col-12'>
    <hr/>
    <h4 class="text-center"> Current Subscription Info</h4>
    <table class="table">
        <tr>
            <td> Id</td>
            <td> {{subscription.server_subscription_id}}</td>
        </tr>
        <tr>
            <td> Class</td>
            <td> {{subscription.level_short_name}}</td>
        </tr>
        <tr>
            <td> Start</td>
            <td> {{subscription.start_date}}</td>
        </tr>
        <tr>
            <td> End</td>
            <td> {{subscription.end_date}}</td>
        </tr>
    </table>
    <fieldset class="buttons text-center">
        <button [disabled]="adminExtending" (click)="adminExtendEnrolmentModalShow(subscription.server_enrolment_id)" class="btn btn-outline-primary ml-2">
            <span *ngIf="adminExtending" class="spinner-border spinner-border-sm me-1"></span>
            Admin Extend
        </button>
        <button [disabled]="adminUpdatingVersion" (click)="adminUpdateVersion(subscription.server_enrolment_id)" class="btn btn-outline-primary ml-2">
            <span *ngIf="adminUpdatingVersion" class="spinner-border spinner-border-sm me-1"></span>
            Update Version
        </button>
        <a routerLink='/admin/student/index' class="btn btn-outline-primary ml-2">
            Student List
        </a>
    </fieldset>
</div>

</div>

<app-enrol-admin-extend *ngIf="current_server_enrolment_id"
[studentDetail]="student"
[enrolment_extend_id]="enrolment_extend_id"
(closeModalRequest)="closeModal($event)"></app-enrol-admin-extend>

<app-spinner *ngIf="loading"></app-spinner>
